module.exports = __webpack_public_path__ + "img/2-1.0c7825a7.png";